"use client";

import ShareWithClientButton from "app/detail/[...slug]/src/share-with-client/ShareWithClientButton";
import LoaderDots from "components/icons-svg/LoaderDots";
type Props = {
  propertyId: string;
  bookLabel: string;
  loaderDots: boolean;
  onBookClick: () => void;
  layout: "stacked" | "inline";
  showShare: boolean;
  city?: string;
  country?: string;
};
const BookingActions = ({
  propertyId,
  bookLabel,
  loaderDots,
  onBookClick,
  layout,
  showShare,
  city,
  country
}: Props) => {
  const isStacked = layout === "stacked";
  return <div className={`flex w-full items-start gap-4 ${isStacked ? "flex-col" : "flex-row"}`} data-sentry-component="BookingActions" data-sentry-source-file="BookingActions.tsx">
      {showShare && <div className={isStacked ? "w-full" : "flex-1"}>
          <ShareWithClientButton propertyId={propertyId} city={city} country={country} className='flex h-11 w-full items-center justify-center rounded-[8px] border border-Gray-600 bg-white px-6 py-2 text-[16px] font-bold leading-[28px] text-Gray-600 shadow-[0_4px_16px_0_rgba(34,34,34,0.08)] hover:bg-gray-50' />
        </div>}
      <button id='BookNowButton' type='button' onClick={onBookClick} className={`flex h-11 items-center justify-center rounded-[8px] bg-accent-500 px-6 py-2 text-[16px] font-bold leading-[28px] text-white shadow-[0_4px_16px_0_rgba(34,34,34,0.08)] transition-colors duration-200 hover:opacity-90 ${isStacked || !showShare ? "w-full" : ""}`}>
        {!loaderDots ? bookLabel : <LoaderDots height='60px' width='60px' />}
      </button>
    </div>;
};
export default BookingActions;